import { WidgetLineGraph } from '../Widgets';
import { connect } from 'react-redux';
import { getBillingData } from '../../redux/actions/billing';
import { sumByField, formatDateFromRange } from '../../helpers';
import moment from 'moment-timezone';

const mapStateToProps = (state, ownProps) => ({
  id: 'WidgetRevenue',
  className: ownProps.className,
  width: ownProps.width,
  height: ownProps.height,
  graph: state.billing.WidgetRevenue
    && state.billing.WidgetRevenue.data
    && state.filter.filters.endDate
    && state.filter.filters.startDate ? [state.billing.WidgetRevenue.data.map(item => ({ key: formatDateFromRange(item.dt, state.filter.filters), value: item.bAmt }))] : [],
  exportData: state.billing.WidgetRevenue && state.billing.WidgetRevenue.data && state.filter.filters.endDate && state.filter.filters.startDate ? state.billing.WidgetRevenue.data.map(item => ({ date: item.dt, Revenue: item.bAmt })) : [],
  info: state.billing.WidgetRevenue && state.billing.WidgetRevenueLegendData0 && state.billing.WidgetRevenueLegendData1 ? [{
    amount: sumByField(state.billing.WidgetRevenue.data, 'bAmt'),
    description: "Total billed amount",
    type: "money"
  }, {
    amount: sumByField(state.billing.WidgetRevenueLegendData0.data, 'bAmt'),
    description: "MtD Billed Amount",
    type: "money"
  }, {
    amount: sumByField(state.billing.WidgetRevenueLegendData1.data, 'bAmt'),
    description: "YtD Billed Amount",
    type: "money"
  }] : [],
  filters: {
    oc: state.filter.filters.oc,
    srvcId: state.filter.filters.service,
    startDate: state.filter.filters.startDate,
    endDate: state.filter.filters.endDate,
    tz: state.filter.filters.tz
  },
  colorScheme: ownProps.colorScheme,
  title: ownProps.title,
  onZoom: ownProps.onZoom,
  dataLoaded: state.billing.WidgetRevenue && state.billing.WidgetRevenue.loaded,
  filtersLoaded: state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.endDate
    && state.filter.filters.startDate,
  loaded: state.billing.WidgetRevenue
    && state.billing.WidgetRevenue.loaded
    && state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.endDate
    && state.filter.filters.startDate,
  shouldLoadData: !state.billing.WidgetRevenue || (!state.billing.WidgetRevenue.loaded && !state.billing.WidgetRevenue.loading && !state.billing.WidgetRevenue.error)
})

const mapDispatchToProps = (dispatch) => ({
  fetchData: (params, id) => {
    dispatch(getBillingData(params, id));
    dispatch(getBillingData({
      ...params,
      startDate: new Date(moment(params.endDate).tz('GMT').startOf('month')),
    }, `${id}LegendData0`));
    dispatch(getBillingData({
      ...params,
      startDate: new Date(moment(params.endDate).tz('GMT').startOf('year'))
    }, `${id}LegendData1`));
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(WidgetLineGraph)



// WEBPACK FOOTER //
// ./src/components/ConnectedWidgets/WidgetRevenueConnected.js